import React, { Suspense, useEffect, useState } from 'react';
import { Redirect, Route, Switch, withRouter, useLocation, useParams } from 'react-router-dom';
import routes from '../constants/router';
import { permission } from '../constants';
import MainLayout from '../layout/MainLayout';

const Routes = () => {
  const [publicRouteList, setPublicRouteList] = useState([]);
  const [isGenerated, setIsGenerated] = useState(false);
  const params = useParams();
  const location = useLocation();
  useEffect(() => {
    generatedRoutes(routes);
  }, []);

  //   useEffect(() => {
  //     nprogress.done()
  //     return () => nprogress.start()
  //   })
  const permissionsRoutes = (routes) => {
    const generated = routes.filter(
      (item) =>
        permission?.find((i) => i.key === item?.meta?.permission) ||
        item?.children?.filter((item) => permission?.find((i) => i.key === item?.meta?.permission))?.length
    );
    return routes;
  };
  const token = localStorage.getItem('token');
  function generatedRoutes(rout) {
    permissionsRoutes(rout).forEach((e, i) => {
      if (e.children && e.children.length) {
        setPublicRouteList((old) => [...old, <AppRoute key={e} exact path={e.path} component={e.component} />]);
        generatedRoutes(e.children);
      } else {
        setPublicRouteList((old) => [...old, <AppRoute key={e} exact path={e.path} component={e.component} />]);
        setIsGenerated(true);
      }
    });
  }

  const AppRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) => (
        <Suspense fallback={<>Loading....</>}>
          <Component {...props} />
        </Suspense>
      )}
    />
  );

  return (
    <>
      {isGenerated ? (
        <Switch>
          {token ? (
            // undefined
            <MainLayout>{publicRouteList}</MainLayout>
          ) : (
            <Redirect from='*' to={`/login${location.search}`} />
          )}
        </Switch>
      ) : undefined}
    </>
  );
};

export default withRouter(Routes);
